import React from 'react'

export const UserPreferencesHeadingPrimary:React.FC<{heading: string}> = ({heading}) => {
  return (
    <div className="text-center text-primary font-semibold text-lg px-[35px] leading-[24px]">
      {heading}
    </div>
  )
}
